import StaticHeaderTwo from './component.styles'
export default StaticHeaderTwo
